import { Stack } from '@chakra-ui/react';
import { dataTypeOptions } from '@pelicargo/utils';

import { SimpleInput } from '../SimpleInput';
import { SimpleSelect } from '../SimpleSelect';

type Props = {
  prefix: string;
  isFirst: boolean;
  isLast: boolean;
  hasMultiple: boolean;
};

export const ProviderDataMapForm = ({ prefix }: Props) => {
  return (
    <>
      <Stack direction="column" spacing="4" w="full" borderWidth={1} p={2} borderRadius="md">
        <SimpleInput name={`${prefix}.id`} hidden />
        <Stack direction="row">
          <SimpleInput
            name={`${prefix}.checkValue`}
            label="Check Value"
            helper="This is the value coming from the API we want to transform."
            flex={3}
          />
          <SimpleSelect name={`${prefix}.checkValueType`} label="Data Type" options={dataTypeOptions} flex={1} />
        </Stack>
        <Stack direction="row">
          <SimpleInput
            name={`${prefix}.resultValue`}
            label="Result Value"
            helper="This is the transformed value."
            flex={3}
          />
          <SimpleSelect name={`${prefix}.resultValueType`} label="Data Type" options={dataTypeOptions} flex={1} />
        </Stack>
      </Stack>
    </>
  );
};
